module.exports = __webpack_public_path__ + "static/media/6.07d01c11.png";